export const CurrencySymbol = Object.freeze({
  SWISSFRANC: 'CHF',
  USDOLLAR: '$',
  EURO: '€'
})
